import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setTeacherAndEnrolledList,
    setLoading,
    setError,
    setPagination,
    resetTeacherAndEnrolledList,
} from "../reducers/getTeacherAndEnrolledListReducer";

// type = "teacher_list" | "enrolled_students"
const getTeacherAndEnrolled = (token: any, type: string, teacher_id?: string, sort?:string, grade?: string, search?: string, school_id?:string, subject_id?: string, role?:string, page?: number  ) => async (
    dispatch: Dispatch
) => {
    dispatch(setLoading(true));
    try {
        const params = new URLSearchParams({ type });
        if (teacher_id) params.append("teacher_id", teacher_id);
        if (sort)       params.append("sort", sort);
        if (grade)      params.append("grade", grade);
        if (search)     params.append("search", search);
        if (type === "teacher_list" && school_id) {
            params.append("school_id", school_id);
        }
        if (subject_id)  params.append("subject_id", subject_id);
        if (role)        params.append("role", role);
        if (type === "enrolled_students") {
            if (page)       params.append("page", String(page));
        }
        // if (page)       params.append("page", String(page));
        // Build URL based on type
        // teacher_list  → /adminpage/access-control/teacher-and-enrolled/?type=teacher_list
        // enrolled_students → /adminpage/access-control/teacher-and-enrolled/?type=enrolled_students&teacher_id=xxx

        const result = await api.get(`adminpage/access-control/teacher-and-enrolled/?${params.toString()}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setLoading(false));
            if (result.data?.status === 200) {
                dispatch(setTeacherAndEnrolledList(result.data.data));
                dispatch(setPagination(result.data));
            } else {
                dispatch(setError(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
        dispatch(setError(error.response?.data?.message ?? "Something Went Wrong!"));
    }
};

export { getTeacherAndEnrolled, resetTeacherAndEnrolledList };